<!-- <div class="opciones">
    <div class="col-md-12">
        <p>
            Elija la opción hacia donde quiere ir.
        </p>
    </div>
    <div class="col-md-12">
        <a target="_blank" [href]="filedomSolicitudUrl">

            <button mat-raised-button color="primary">Solicitud de Certificados</button>
        </a>
 
    </div>
    
    <div *ngIf="nombreMuni!='Prueba Solnet'" class="col-md-12" style="padding-top: 10px;">
        <button mat-raised-button color="primary" (click)="seguimiento()">Seguimiento de Certificados</button>
    </div>
</div> -->

<!-- <div class="container-header">
    <mat-toolbar color="#01BAC9" style=" background-color: rgb(1, 186, 201);">
        <mat-toolbar-row>
            <span class="logo">
                <a class="navbar-brand" href="/#/inicio">
                    <img style="max-height: 53px;" src="assets/images/generico/logo.png" alt="Inicio icono">
                </a>
            </span>
            <span class="example-spacer"></span>
        </mat-toolbar-row>
    </mat-toolbar>
</div> -->
<!-- <div class="container"> -->
<!--     
    <div class="row" align="right">
        <button class="btn_danger" mat-button (click)="cerrar_vista()">Salir</button>
    </div>

    <div class="row" style="width: 100%; height: 150px; margin-bottom: 3%;">
        <div class="title1"> Solicitudes con pago en línea</div>

    </div> -->

<div class="opciones">
    <!-- <div class="col-md-12">
            <p>
                <b> Elija la opción hacia dónde quiere ir:</b>
            </p>
        </div> -->
    <div class="col-md-12 margin" style="padding-top: 10px;">
        <h4 class="card-title"> Certificados </h4>
        <li *ngFor="let i of solicitudesPago" class="special-list">{{ i }} </li>
        <br>
        <div style="text-align: center;">
          <!--   <a target="_blank" [href]="filedomSolicitudUrl">
                <button mat-raised-button class="button-special-pa">Solicitud de Certificados</button>
            </a> -->
            <a target="_blank">
                <button mat-raised-button class="button-special-pa"
                    (click)="sign('certificados')">Solicitud de Certificados</button>
            </a>
        </div>
        <div style="text-align: center; margin: 5px;">
            <a target="_blank">
                <button mat-raised-button class="button-special-pa"
                    (click)="sign('seguimiento-certificados')">Seguimiento de Certificados</button>
            </a>
        </div>
    </div>

</div>

<!-- </div> -->